import React from "react";
import riftRedLogo from "../../../../assets/images/rift-red.svg";
const DeviseHeader = () => { return /*#__PURE__*/ React.createElement("header", { className: "auth__header" }, /*#__PURE__*/ React.createElement("img", { src: riftRedLogo, className: "auth__logo", alt: "RIFT" })); };
export default DeviseHeader;
